module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vendo2-fe177f0fb60762ffaa4bb14137dcd3af.jpg";